import { PORTFOLIO } from "@/content/portfolio";
import { siteConfig } from "@/config/site";

export function HomeTrustBar() {
  const domains = PORTFOLIO.map((p) => p.domain);
  return (
    <section className="border-y border-border bg-[color-mix(in_oklab,var(--surface)_60%,transparent)]">
      <div className="container-page py-8 md:py-10">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="text-[0.7rem] uppercase tracking-[0.22em] text-muted-foreground shrink-0">
            {siteConfig.contact.address.city} &amp; Central Texas operators · real GSC + Semrush data
          </div>
          <div className="flex-1 overflow-hidden">
            <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
              {domains.map((d) => (
                <div
                  key={d}
                  className="font-display text-lg md:text-xl text-foreground/70 hover:text-foreground transition-colors"
                >
                  {d}
                </div>
              ))}
              <div className="text-xs text-muted-foreground">
                + confidential engagements under NDA
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
